(() => {
  'use strict';
  if (window.__printoraHomeV27) return;
  window.__printoraHomeV27 = true;

  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (!root || root.dataset.v27CarouselReady === '1') return;
    root.dataset.v27CarouselReady = '1';

    const slides = [...root.querySelectorAll('[data-pv27-home-slide]')];
    const dots = [...root.querySelectorAll('[data-pv27-home-dot]')];
    const prev = root.querySelector('[data-pv27-home-prev]');
    const next = root.querySelector('[data-pv27-home-next]');
    if (slides.length < 2) return;

    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    let startX = null;
    let startY = null;
    let horizontalSwipe = false;
    let delay = parseInt(root.dataset.delay || '5000', 10);
    if (!Number.isFinite(delay) || delay < 2500) delay = 5000;

    function hydrate(slide) {
      if (!slide || slide.dataset.hydrated === '1') return;
      slide.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      slide.querySelectorAll('img[data-src]').forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
      slide.dataset.hydrated = '1';
    }

    function paint(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      hydrate(slides[index]);
      hydrate(slides[(index + 1) % slides.length]);
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (reduceMotion || document.hidden) return;
      timer = window.setInterval(() => paint(index + 1), delay);
    }

    prev?.addEventListener('click', () => { paint(index - 1); start(); });
    next?.addEventListener('click', () => { paint(index + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { paint(parseInt(dot.dataset.pv27HomeDot || '0', 10)); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) start(); });

    root.addEventListener('touchstart', (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
      horizontalSwipe = false;
      stop();
    }, { passive: true });

    root.addEventListener('touchmove', (event) => {
      if (startX == null || startY == null) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (!horizontalSwipe && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.15) horizontalSwipe = true;
      if (horizontalSwipe && event.cancelable) event.preventDefault();
    }, { passive: false });

    root.addEventListener('touchend', (event) => {
      if (startX == null) return;
      const touch = event.changedTouches && event.changedTouches[0];
      const dx = touch ? touch.clientX - startX : 0;
      startX = null;
      startY = null;
      horizontalSwipe = false;
      if (Math.abs(dx) >= 42) paint(index + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });

    root.addEventListener('touchcancel', () => {
      startX = null;
      startY = null;
      horizontalSwipe = false;
      start();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    hydrate(slides[(index + 1) % slides.length]);
    start();
  }

  function initFeatured(root) {
    if (!root || root.dataset.pv27FeaturedReady === '1') return;
    root.dataset.pv27FeaturedReady = '1';
    const track = root.querySelector('[data-pv27-featured-track]');
    const cards = track ? [...track.querySelectorAll('[data-pv27-featured-card]')] : [];
    const prev = root.querySelector('[data-pv27-featured-prev]');
    const next = root.querySelector('[data-pv27-featured-next]');
    if (!track || cards.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    let stateFrame = 0;
    const getStep = () => {
      if (cards.length > 1) {
        const a = cards[0].getBoundingClientRect();
        const b = cards[1].getBoundingClientRect();
        const measured = Math.abs(b.left - a.left);
        if (measured > 0) return measured;
      }
      return cards[0].getBoundingClientRect().width + 16;
    };
    const updateState = () => {
      stateFrame = 0;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    const scheduleState = () => {
      if (stateFrame) return;
      stateFrame = window.requestAnimationFrame(updateState);
    };
    const move = (direction) => {
      track.scrollBy({ left: direction * getStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', scheduleState, { passive: true });
    window.addEventListener('resize', scheduleState, { passive: true });
    updateState();
  }

  function boot(scope = document) {
    scope.querySelectorAll?.('[data-pv27-home-carousel]').forEach(initCarousel);
    scope.querySelectorAll?.('[data-pv27-featured]').forEach(initFeatured);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
